/**
 * @file   src\mobile\components\Onboarding\MemberProfile.js
 * @brief  This file is responsible for adding member profile while onboaring.
 * @date   June, 2024
 * @author ZCO Engineer
 * @copyright (c) 2024, ZCO
 */
import React, { useState, useEffect } from "react";
import { nameValidation } from "../../../helpers/validations";
import { getLocalStorage, toTitleCase } from "../../../helpers/common";
import Button from "react-bootstrap/Button";
import FldCloseIcon from "../../images/round-close-icon.svg";
import TextBox from "../../../components/Common/TextBox";
import ValidationAlertIcon from "../../images/validation-alert-icon.svg";
import { USER_INFO_KEY } from "../../../constants/common";
import TopHeader from "../common/TopHeader";

const MemberProfile = (props) => {
  const { handlMemberDeatilsSave } = props;
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [firstNameError, setFirstNameError] = useState("");
  const [lastNameError, setLastNameError] = useState("");

  const handleFirstName = (name) => {
    setFirstNameError("");
    setFirstName(name);
  };

  const handleLastName = (name) => {
    setLastNameError("");
    setLastName(name);
  };

  const clearField = (field) => {
    if (field === "fName") {
      setFirstName("");
    } else {
      setLastName("");
    }
  };

  useEffect(() => {
    const userDetails = getLocalStorage(USER_INFO_KEY);
    const firstName = _.get(userDetails, "userInfo.firstName", null);
    const lastName = _.get(userDetails, "userInfo.lastName", null);
    firstName && setFirstName(firstName);
    lastName && setLastName(lastName);
  }, []);

  /**
   * To handle validation
   */
  const handleContinue = () => {
    setFirstNameError("");
    setLastNameError("");
    let isValid = true;
    if (firstName && !nameValidation(firstName.trim())) {
      isValid = false;
      setFirstNameError("Invalid input");
    }
    if (lastName && !nameValidation(lastName.trim())) {
      isValid = false;
      setLastNameError("Invalid input");
    }
    if (isValid) {
      handlMemberDeatilsSave(firstName, lastName);
    }
  };
  return (
    <div className="gitcha-main-wrapper pb-0 bg-grey-variant">
      <div className="content-wrapper pt-0 h-100">
        <TopHeader
          variant={"review"}
          outerClassname="bg-transparent d-none"
          topClassName="w-100"
          bottomClassName="signup-header-txt clearfix"
          allowPremiumOverride={false}
        >
        </TopHeader>
        <div className="inner-layout-content-new h-100">
          <div className="get-agent-wrap pt-5 clearfix">
            <h2 className="pb-3">Let’s complete your profile</h2>

            <div className="row">
              <div className="col-6 pe-2">
                <div className="mob-fld-wrap position-relative mb-2">
                  <label className="form-label">
                    First name <span>*</span>
                  </label>

                  <TextBox
                    id="fName"
                    name="fName"
                    type="text"
                    value={toTitleCase(firstName)}
                    placeholder="First name"
                    className={
                      firstNameError
                        ? "validation-alert-brdr form-control mob-pr-44"
                        : "form-control mob-pr-44"
                    }
                    onChange={(e) => handleFirstName(e.target.value)}
                    errorClass="error-validation-msg"
                    errorMessage={firstNameError}
                  />
                  {firstName && !firstNameError && (
                    <Button
                      variant=""
                      className="fld-close-btn"
                      onClick={() => clearField("fName")}
                    >
                      <img src={FldCloseIcon} />
                    </Button>
                  )}
                  {firstNameError && (
                    <div className="validation-alert">
                      <img src={ValidationAlertIcon} />
                    </div>
                  )}
                </div>
              </div>
              <div className="col-6 ps-2">
                <div className="mob-fld-wrap position-relative mb-2">
                  <label className="form-label">
                    Last name <span>*</span>
                  </label>

                  <TextBox
                    id="lName"
                    name="lName"
                    type="text"
                    value={toTitleCase(lastName)}
                    placeholder="Last name"
                    className={
                      lastNameError
                        ? "validation-alert-brdr form-control mob-pr-44"
                        : "form-control mob-pr-44"
                    }
                    errorClass="error-validation-msg"
                    onChange={(e) => handleLastName(e.target.value)}
                    errorMessage={lastNameError}
                  />
                  {lastName && !lastNameError && (
                    <Button
                      variant=""
                      className="fld-close-btn"
                      onClick={() => clearField()}
                    >
                      <img src={FldCloseIcon} />
                    </Button>
                  )}
                  {lastNameError && (
                    <div className="validation-alert">
                      <img src={ValidationAlertIcon} />
                    </div>
                  )}
                </div>
              </div>
            </div>
            <Button
              variant="primary"
              className="btn w-100 mb-4"
              disabled={firstName === "" || lastName === "" ? true : false}
              onClick={() => handleContinue()}
            >
              Continue
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MemberProfile;
